// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"5e88b3ac","247":"b93ff7df","422":"189dba55","627":"08c7bb32","653":"47235818","834":"9bd66688","867":"6d5cd9db","923":"99c2ad06","938":"a71a0fb4"}[chunkId] + ".chunk.js";
};